import React, {useEffect, useState} from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {ApiParam} from "../../api/network/apiParams";
import {fetchWriting} from "../../api/redux/writing";
import {useLocation} from "react-router-dom";
import {useSearch} from "../../components/context/SearchContext";

const Writings = () => {
    const dispatch = useDispatch();
    const location = useLocation(); // Get the location object
    const [groupedData, setGroupedData] = useState([]);
    const { query, setQuery } = useSearch();

    // Parse query parameter from the URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlQuery = params.get("query");
        if (urlQuery) {
            setQuery(urlQuery); // Set query from URL
        }
    }, [location.search]);

    // API call
    useEffect(() => {
        const api_url = apiEndPoints.BLOG_LIST;
        const api_params = {
            [ApiParam.IMAGE]: "no",
            [ApiParam.POST]: "yes",
        };

        dispatch(fetchWriting([api_url, api_params]));
    }, [dispatch]);

    const getPost = useSelector((state) => state.writing);
    const data = getPost?.posts?.blogs;
    const filteredWriting = data?.filter((writing) => writing.data?.category_id === 20);

    // Group and sort data whenever `data` changes
    useEffect(() => {
        if (Array.isArray(filteredWriting)) {
            const grouped = filteredWriting.reduce((acc, item) => {
                if (item && item.data) {
                    const link = item.data.link || "Unknown";

                    // Find existing group for the link
                    let group = acc.find((g) => g.link === link);

                    if (!group) {
                        // If group doesn't exist, create a new one
                        group = { link, items: [] };
                        acc.push(group);
                    }

                    // Add the current item to the group's items
                    group.items.push(item);
                } else {
                    console.warn("Invalid item structure: ", item);
                }

                return acc;
            }, []);

            setGroupedData(grouped); // Update the state with sorted data
        } else {
            console.error("Data is not an array or is undefined.");
        }
    }, [data]); // Run this effect whenever `data` changes

    const filteredData = groupedData.map(group => {
        const filteredItems = group.items.filter(item => {
            const productData = item?.data;

            // Safely check and convert each field to a string before calling `toLowerCase`
            return (
                productData?.title?.toLowerCase()?.includes(query.toLowerCase()) ||
                productData?.date?.toLowerCase()?.includes(query.toLowerCase())
            );
        });

        // Return only groups with matching items
        return { ...group, items: filteredItems };
    }).filter(group => group.items.length > 0); // Remove empty groups

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Writings</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."/>
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row>
                        <Col lg={12}>
                            {filteredData?.map((group, index) => {
                                return (
                                    <div key={index}>
                                        <div className="category">
                                            <h5>{group.link}</h5>
                                        </div>
                                        {group.items.map((item, idx) => {
                                            return (
                                                <ListComponent key={idx} category={item?.slug} url={'writings'}
                                                               data={item}/>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
    .category {
        margin-bottom: 30px;

        h5 {
            font-size: 16px;
            font-weight: bold;
            line-height: 18px;
            font-weight: bold;
        }
    }
`;

export default Writings;
